export default "__VITE_ASSET__ccb7b302__"